import {
    NotificationTemplateForAdmin,
    NotificationTypes,
} from '@sapphicsavvy/business';

export function sortNotificationTemplates(
    templates: NotificationTemplateForAdmin[],
): [NotificationTemplateForAdmin[], NotificationTemplateForAdmin[]] {
    if (!templates || templates.length === 0) {
        return [[], []];
    }

    const typeOrder = [
        NotificationTypes.NEW_QUARTER,
        NotificationTypes.RESULTS_READY,
        NotificationTypes.PLAY_QUARTER_FIRST_REMINDER,
        NotificationTypes.PLAY_QUARTER_SECOND_REMINDER,
    ];

    const quarterTemplates: NotificationTemplateForAdmin[] = [];
    const customTemplates: NotificationTemplateForAdmin[] = [];

    templates?.forEach((template) => {
        if (template.type === NotificationTypes.CUSTOM) {
            customTemplates.push(template);
        } else {
            quarterTemplates.push(template);
        }
    });

    quarterTemplates.sort((a, b) => {
        const indexA = typeOrder.indexOf(a.type);
        const indexB = typeOrder.indexOf(b.type);
        return indexA - indexB;
    });

    return [quarterTemplates, customTemplates];
}
